/**
 * @function parseStringBlock
 * @description Parses a string from block.
 * @param {string} str - String to parse.
 * @returns {{key: string,operator: string, value: string }} - Object with parsed filter.
 */
const parseStringBlock = (str) => {
  const symbols = ['<>', '<', '>', '=', 'like']
  const [key, value = ''] = str.split(':')
  const operator = symbols.find((char) => value.trim().includes(char)) || '='
  let filterValue = value.split(operator)[1]?.trim()
  if (filterValue.includes(',')) {
    filterValue = filterValue.split(',')
  }
  return { key: key.trim(), operator, value: filterValue }
}

/**
 * @function checkFiltersByDataType
 * @description Checks filters by data type and fix them.
 * @param {Object} filters - Filters to check.
 * @returns {{ [key]: {operator: string, value: string  } } | {} } - Object with checked filters.
 */

const checkFiltersByDataType = (filters) => {
  const map = {
    active: 'boolean',
    allPeople: 'number',
    categories: 'array',
    subCategories: 'subCategories',
    followed: 'boolean',
    externalId: 'boolean',
    email: 'string',
    ids: 'array',
    firstName: 'string',
    lastName: 'string',
    nickName: 'string',
    beneficiaryName: 'string',
    website: 'string',
    memberRoles: 'array',
    registrationDate: 'date',
    marketingPromotion: 'boolean',
  }
  return Object.keys(filters).reduce((acum, key) => {
    // Skip marketingPromotion from text search parsing
    if (key === 'marketingPromotion') {
      return acum;
    }

    switch (true) {
      // eslint-disable-next-line valid-typeof
      case typeof filters[key].value === map[key]:
        acum[key] = filters[key]
        return acum
      case typeof filters[key].value === 'object':
        acum[key] = filters[key].value
        return acum
      case map[key] === 'boolean':
        // Regular boolean handling
        filters[key].value = filters[key].value === 'true'
        acum[key] = filters[key]
        return acum
      default:
        return acum
    }
  }, {})
}

/**
 * @function parseFilters
 * @description Parses filters from string.
 * @param {string} str - String to parse.
 * @returns {{ [key]: {operator: string, value: string  } }
 *  | {}| {beneficiaryName: {value, operator: string} }} - Object with parsed filters.
 */
export const parseFilters = (str) => {
  if (!str) return {}
  if (!str.includes(':')) {
    return {
      beneficiaryName: {
        operator: 'like',
        value: str,
      },
    }
  }
  const parseBlocks = str
    .trim()
    .split(';')
    .filter((item) => !!item)
  const filters = {}
  parseBlocks.forEach((block) => {
    const { key, operator, value } = parseStringBlock(block)
    // Skip marketingPromotion from search string
    if (key !== 'marketingPromotion') {
      filters[key] = {
        operator,
        value,
      }
    }
  })
  return checkFiltersByDataType(filters)
}
